import { observer } from 'mobx-react';
import React from 'react';
import { AnalyticsProvider, Heading, Separator, Text } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';

export interface GoodToKnowProps {
  heading?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
  translationKey?: string;
  children: React.ReactChild | React.ReactChild[] | string;
}

const GoodToKnow: React.FC<GoodToKnowProps> = (props: GoodToKnowProps) => {
  const translate = React.useContext(TranslationsContext).translate;
  const { heading, className, translationKey = 'goodToKnow.heading', children } = props;

  return (
    <AnalyticsProvider group={'Good To Know'}>
      <Text>
        <Heading element={heading ?? 'h2'} className={className}>
          {translate(translationKey)}
        </Heading>
        <Separator spacing={'small'} color={'invisible'} />
        {children}
      </Text>
    </AnalyticsProvider>
  );
};

export default observer(GoodToKnow);
